/* Native details keeps mobile navigation usable even when JavaScript is unavailable. */
(() => {
  const menu = document.querySelector('.grothub-mobile-menu');
  if (!menu) return;
  const summary = menu.querySelector('summary');
  const desktop = window.matchMedia('(min-width: 901px)');
  const close = (restoreFocus = false) => {
    menu.open = false;
    if (restoreFocus) summary.focus();
  };
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) close(true);
  });
  document.addEventListener('click', (event) => {
    if (menu.open && !menu.contains(event.target)) close();
  });
  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) close();
  });
  document.addEventListener('focusin', (event) => {
    if (menu.open && !menu.contains(event.target)) close();
  });
  desktop.addEventListener('change', (event) => {
    if (event.matches) close();
  });
  window.addEventListener('pageshow', () => close());
})();

(() => {
  const nav = document.querySelector('.nav');
  if (!nav) return;
  let backToTop = document.querySelector('.back-to-top');
  if (!backToTop) {
    backToTop = document.createElement('button');
    backToTop.className = 'back-to-top';
    backToTop.type = 'button';
    backToTop.setAttribute('aria-label', 'Back to top');
    backToTop.title = 'Back to top';
    backToTop.innerHTML = '<span aria-hidden="true">↑</span>';
    document.body.appendChild(backToTop);
  }

  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.grothub-desktop-nav a, .grothub-mobile-nav a').forEach((link) => {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
    link.classList.toggle('active', linkPath === currentPath);
    if (linkPath === currentPath) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });

  let lastY = window.scrollY;
  let ticking = false;
  const update = () => {
    const currentY = window.scrollY;
    const movingDown = currentY > lastY + 5;
    const movingUp = currentY < lastY - 5;
    if (currentY < 90 || movingUp) nav.classList.remove('is-hidden');
    else if (movingDown && !document.querySelector('.grothub-mobile-menu[open]')) nav.classList.add('is-hidden');
    backToTop.classList.toggle('is-visible', currentY > 160);
    lastY = currentY;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  backToTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
